import root from 'window-or-global';

import {breakpoints} from '../../constants';

// Singleton utility to listen for window resize events and publish updates to subscribers
class ResizeManager {
    subscribers = {};
    didInit = false;
    running = false;
    currentKey = 0;

    _init() {
        this.didInit = true;

        root.addEventListener('resize', this._onResize);
        this._updateSizes();
    }

    _onResize = () => {
        if (!this.running) {
            this.running = true;
            root.requestAnimationFrame(this._updateSizes);
        }
    };

    _updateSizes = () => {
        this.dimensions = {
            height: root.innerHeight,
            width: root.innerWidth
        };
        this.breakpoint = this._getBreakpoint();
        this._publish();
        this.running = false;
    };

    _getBreakpoint = () => {
        let breakpoint;

        Object.keys(breakpoints.value).some(bp => {
            if (this.dimensions.width >= breakpoints.value[bp]) {
                breakpoint = bp;
                return true;
            }

            return false;
        });

        return breakpoint;
    };

    _publish = () => {
        Object.keys(this.subscribers).forEach(key => {
            const callback = this.subscribers[key];
            callback(this.getProps());
        });
    };

    getProps = () =>
        this.didInit && {
            breakpoint: this.breakpoint,
            dimensions: this.dimensions
        };

    subscribe = fn => {
        if (!this.didInit) this._init();

        fn(this.getProps());

        this.currentKey += 1;
        this.subscribers[this.currentKey] = fn;

        return this.currentKey;
    };

    unsubscribe = key => {
        delete this.subscribers[key];
    };
}

export default new ResizeManager();
